var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpense(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5504_31331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0L6 3H7V5H9V3H10L8 0ZM15 15V7H1V15H15ZM16 16H0V6H16V16Z",
    fill: "#AEB7C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 14C8.79565 14 9.55871 13.6839 10.1213 13.1213C10.6839 12.5587 11 11.7956 11 11C11 10.2044 10.6839 9.44129 10.1213 8.87868C9.55871 8.31607 8.79565 8 8 8H13V9H14V13H13V14H8ZM5 11C5 11.7956 5.31607 12.5587 5.87868 13.1213C6.44129 13.6839 7.20435 14 8 14H3V13H2V9H3V8H8C7.20435 8 6.44129 8.31607 5.87868 8.87868C5.31607 9.44129 5 10.2044 5 11Z",
    fill: "#AEB7C9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5504_31331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpense);
export default __webpack_public_path__ + "static/media/expense.603e426327ffcce9b1247b4e370af132.svg";
export { ForwardRef as ReactComponent };